module.exports = __webpack_public_path__ + "img/sld_mppt_2_t1_b1_green.29ca5676.svg";